import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';

import { ORGANIZATION_CONFIG_SET } from './constants';
import { OrganizationConfigState, OrganizationConfigActions } from './types';

const initialState = null;

export default function (
    state: OrganizationConfigState = initialState,
    action?: OrganizationConfigActions
): OrganizationConfigState {
    if (!action) return state;
    switch (action.type) {
        case ORGANIZATION_CONFIG_SET:
            return get(action, 'payload', initialState);
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
